import { calculateDiffYears } from "@goodfill/date";
import { includeGoodfillCommissionWithBasePrice, calculateProfitAndLoss } from "@goodfill/domain-math";
import { Currency, Money, OrderDirection } from "@goodfill/domain-properties";
import { DateTime } from "luxon";
import { PresentedPortfolioPosition } from "../../../account/portfolio/positions/PresentedPortfolioPosition";
import { PricedBond } from "../../../bonds/PricedBond";
import { PortfolioPositionTradeTicket } from "./PortfolioTradeTicket";

export const mapPortfolioTradeTicketToPresentedPosition = (
  tradeTicket: PortfolioPositionTradeTicket,
  pricedBond: PricedBond,
): PresentedPortfolioPosition => {
  const loadedBuyPrice = includeGoodfillCommissionWithBasePrice(
    tradeTicket.bondPrice,
    { amount: tradeTicket.amount, currency: Currency.USD },
    OrderDirection.Buy,
  );

  const loadedSellPrice = includeGoodfillCommissionWithBasePrice(
    pricedBond.bidPrice,
    { amount: tradeTicket.amount, currency: Currency.USD },
    OrderDirection.Sell,
  );

  const availableToSellMoneyAmount: Money = {
    amount: tradeTicket.availableToSell,
    currency: Currency.USD,
  };

  return {
    id: tradeTicket.id,
    orderTicketId: tradeTicket.orderTicket.id,
    bondId: pricedBond.bondIdCusip,
    issuerId: pricedBond.issuerId,
    tradeDate: tradeTicket.tradeDate,
    direction: tradeTicket.orderTicket.direction,
    ticker: pricedBond.issuerTicker,
    issuerName: pricedBond.issuerName,
    paymentRank: pricedBond.paymentRank,
    isin: pricedBond.isin,
    couponPayment: pricedBond.couponPayment,
    maturityDate: pricedBond.maturityDate,
    loadedBuyPrice,
    currentLoadedBidPrice: loadedSellPrice,
    accruedInterest: tradeTicket.accruedInterest,

    yearsHeld: calculateDiffYears(DateTime.local(), tradeTicket.tradeDate),
    yearsToMaturity: calculateDiffYears(pricedBond.maturityDate, DateTime.local()),

    amount: tradeTicket.amount,
    lockedInOrders: tradeTicket.lockedInOrder,
    availableToSell: tradeTicket.availableToSell,

    pnlRealized: tradeTicket.pnlRealized,
    plnUnrealizedInOrders: tradeTicket.plnUnrealizedInOrders,
    plnUnrealizedAvailableToSell: calculateProfitAndLoss(availableToSellMoneyAmount, loadedBuyPrice, loadedSellPrice),

    bondRatingMoodys: pricedBond.ratings.moodys,
    bondRatingSp: pricedBond.ratings.sp,
  };
};
